import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '@/utils/cn';
import styles from './Separator.module.scss';
import type { SeparatorProps } from './Separator.types';

/**
 * Separator - Visual divider between content sections
 * Based on Radix UI Separator with SCSS styling
 *
 * @example
 * <Separator />
 * <Separator orientation="vertical" />
 */
export const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => {
  const separatorClasses = cn(
    styles.separator,
    styles[`separator--${orientation}`],
    className
  );

  return (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={separatorClasses}
      {...props}
    />
  );
});

Separator.displayName = 'Separator';
